import moment from 'moment';

export default {
  // NOTE: name is singular
  name: 'lifeEvent',
  isPublishable: true,
  isDuplicable: true,
  uniqKey: '_id',
  crudMapping: {
    create: 'createLifeEvent',
    readMany: 'lifeEvents',
    readOne: 'lifeEvent',
    update: 'updateLifeEvent',
    // createTemplate: 'createSampleLifeEvent',
    // delete: 'deleteLifeEvent',
  },
  readManySchema: {
    // NOTE for now this is a hack since we can only render
    // one field for this object
    cellFormatter(value, object, fieldName) {
      if (fieldName === '_companies') {
        return value
          .map(company => company.name)
          .reduce(
            (acc, companyName) =>
              (acc.includes(companyName) ? acc : [...acc, companyName]),
            [],
          )
          .join(', ');
      }
      if (fieldName === 'published') {
        return value ? 'Yes' : 'No';
      }
      if (value && typeof value === 'object') {
        return value.title;
      }
      if (fieldName === 'updatedAt') {
        if (!value) {
          const date = new Date(
            parseInt(object._id.substring(0, 8), 16) * 1000,
          );
          return moment(date).format('MM/DD/YYYY hh:mm a');
        }
        return value
          ? moment(new Date(value)).format('MM/DD/YYYY hh:mm a')
          : '';
      }
      return value;
    },
    jsonSchema: {
      type: 'object',
      properties: {
        title: {
          title: 'Life Event',
          type: 'string',
        },
        _adminWordsPhrases: {
          title: 'Words & Phrases',
          type: 'number',
        },
        _adminAudioVideo: {
          title: 'Audio & Video',
          type: 'number',
        },
        _adminGiftsGoodwill: {
          title: 'Gifts & Goodwill',
          type: 'number',
        },
        _adminEventsExperiences: {
          title: 'Events & Experiences',
          type: 'number',
        },
        dropCount: {
          title: 'Encour. Count',
          type: 'number',
        },
        stickyCount: {
          title: 'Sticky Encour.',
          type: 'number',
        },
        published: {
          type: 'boolean',
        },
        _companies: {
          title: 'Companies',
          type: 'object',
          properties: {
            name: {
              type: 'string',
            },
          },
        },
        updatedAt: {
          title: 'Last Updated',
          type: 'string',
        },
      },
    },
  },
  defaultSchema: {
    jsonSchema: {
      description:
        'Complete all required* fields below. You may Save or Publish this life event. Your progress will not be saved if you exit the page.',
      type: 'object',
      required: [
        'title',
        'subTitle',
        'imageId',
        'lifeEventCategoryIds',
        'dropIds',
      ],
      properties: {
        basics: {
          type: 'string',
          title: 'Basics',
          displayOnly: true,
        },
        published: {
          type: 'boolean',
          default: true,
        },
        title: {
          type: 'string',
          title: 'Life Event Title',
          description: 'What is the title of this Encouragement Guide?',
        },
        subTitle: {
          type: 'string',
          title: 'Life Event Sub-title',
          description:
            'Input key words or phrases to help users search for this life event',
        },
        lifeEventCategoryIds: {
          type: 'array',
          title: 'Life Event Categories',
          description:
            'Select or search for catagories related to this live event.',
          items: {
            type: 'string',
          },
        },
        slug: {
          type: 'string',
          title: 'URL Slug',
          description:
            'Input lower case, no spaces (company + life even title) EXAMPLE: modernmotherhoodadoption',
        },
        imageId: {
          type: 'string',
          title: 'Thumbnail Image',
          hint: 'Please upload a high definition image',
          description:
            'This image will appear on thumbnail cards when searched by users. Image Ratio 2X1, Landscape',
        },
        heroImage: {
          type: 'string',
          title: 'Header Image',
          hint: 'Please upload a high definition image',
          description:
            'This image will appear as the header image for this life event (e-guide). Image Raio 3:2, Landscape',
        },
        private: {
          type: 'boolean',
          title: 'Private Life Event',
          description:
            'Check this box if you do no want this life event to be shared or viewed by "non-subscribers" to you collection',
          default: false,
        },
        canBeUsedAsTemplate: {
          type: 'boolean',
          title: 'Allow to be used as template',
          description: '',
          default: false,
        },
        meta: {
          type: 'string',
          title: 'Metadata',
          description:
            'Metadata shapes how this e-guide will be searched and shared across the web',
          displayOnly: true,
        },
        metadata: {
          type: 'object',
          title: '',
          properties: {
            title: {
              type: 'string',
              title: 'Sharing Title',
              hint: 'example: Encourage someone experiencing [this life event]',
              description:
                'Craft an engaging title. This title will appear when users share this E-Guide on social media. ',
            },
            description: {
              type: 'string',
              title: 'Page Description',
              hint: 'Example: It can be hard to know what to say to encourage someone, or what to do to make things easier. Here are some ideas that could help.',
              description: 'Summarize this E-Guide in 200 characters.',
            },
            image: {
              type: 'string',
              title: 'Thumbnail Image',
              hint: 'Please upload a high definition image',
            },
          },
        },
        // durationDescription: {
        //   type: 'string',
        // },
        curation: {
          type: 'string',
          title: 'Curator Information',
          description: 'Leave this section blank if there is no curator',
          displayOnly: true,
        },
        curationTitle: {
          type: 'string',
          title: 'Curation Title',
          description: 'This message appears above the curators name.',
        },
        curatorName: {
          type: 'string',
          title: 'Curator Name',
          description: 'Include their full name and credientials.',
        },
        curatorBio: {
          type: 'string',
          title: 'Curator Biography',
          description:
            'Write 2-3 sentences about the Curator and their credentials.',
        },
        curatorImage: {
          type: 'string',
          title: 'Curator Image',
          hint: 'Please upload a high definition image',
          description:
            'This image will appear when users share this E-Guide on social media.',
        },
        eguide: {
          type: 'string',
          title: 'E-Guide Content',
          displayOnly: true,
        },
        showTBYB: {
          title: 'Enable Try Before You Buy Section',
          description:
            'Check this box if you do no want users to see encouragement recommendations associated with this life event page',
          type: 'boolean',
          default: true,
        },
        sideImages: {
          type: 'array',
          title: 'Side Images',
          description:
            'These images will be displayed on the top right of article (Your logo, Featured Sponsors), Max of 2 images, 1X1 image ratio',
          default: [],
          items: {
            type: 'object',
            required: ['src', 'sortIndex'],
            properties: {
              src: {
                type: 'string',
                title: 'Image File',
              },
              sortIndex: {
                type: 'number',
                title: 'Major Sort Index',
                description:
                  'Input number in all Major Sort Index fields if you wish to rearrenge order in page',
                default: 0,
              },
              url: {
                type: 'string',
                title: 'Image link',
              },
            },
          },
          maxItems: 2,
        },
        lifeEventContentItems: {
          type: 'array',
          title: '',
          items: {
            type: 'object',
            properties: {
              itemTitle: {
                type: 'string',
                title: 'Paragraph Title',
              },
              sortIndex: {
                type: 'number',
                title: 'Major Sort Index',
                description:
                  'Input number in all Major Sort Index fields if you wish to rearrenge order in page',
              },
              itemContent: {
                type: 'string',
                title: 'Content',
              },
              visible: {
                type: 'boolean',
                title: 'This item appears on E-Guide',
              },
            },
          },
          default: [
            {
              itemTitle: 'He or She Might Be Thinking About...',
            },
            {
              itemTitle: 'Words That Might Be Encouraging',
            },
            {
              itemTitle: 'Words That Might Be Discouraging',
            },
          ],
        },
        galleries: {
          type: 'array',
          title: 'Galleries',
          description: 'Galleries to group up videos and images',
          items: {
            type: 'object',
            required: ['name', 'sortIndex'],
            properties: {
              name: {
                type: 'string',
                title: 'Name',
              },
              description: {
                type: 'string',
                title: 'Subtitle',
              },
              sortIndex: {
                type: 'number',
                title: 'Major Sort Index',
                description:
                  'Input number in all Major Sort Index fields if you wish to rearrenge order in page',
              },
              lifeEventVideos: {
                type: 'array',
                title: 'Videos',
                description:
                  'These videos will appear in the selected Gallery.',
                items: {
                  type: 'object',
                  required: ['src', 'sortIndex'],
                  properties: {
                    src: {
                      type: 'string',
                      title: 'Video Url',
                    },
                    caption: {
                      type: 'string',
                      title: 'Video Caption',
                    },
                    sortIndex: {
                      type: 'number',
                      title: 'Sort index',
                      default: 0,
                    },
                  },
                },
              },
              lifeEventImages: {
                type: 'array',
                title: 'Images',
                description:
                  'These images will appear in the selected Gallery.',
                default: [],
                items: {
                  type: 'object',
                  required: ['src', 'sortIndex'],
                  properties: {
                    src: {
                      type: 'string',
                      title: 'Image File',
                    },
                    caption: {
                      type: 'string',
                      title: 'Image Caption',
                    },
                    url: {
                      type: 'string',
                      title: 'Image Link',
                    },
                    sortIndex: {
                      type: 'number',
                      title: 'Sort index',
                      default: 0,
                    },
                  },
                },
              },
            },
          },
        },
        exeCuration: {
          type: 'string',
          title: 'Encouragement Curation',
          description:
            'Select or search encouragements that will help users encourage someone experiencing this life event.',
          displayOnly: true,
        },
        dropIds: {
          // TODO: separate by type of drop?
          type: 'array',
          title: 'Encouragements',
          default: [],
          items: {
            type: 'string',
          },
        },
        stickyDropIds: {
          type: 'array',
          title: 'Sticky Encouragements',
          default: [],
          items: {
            type: 'string',
          },
        },
        sponsor: {
          type: 'string',
          title: 'Sponsor Logos',
          description:
            'These images will be appear at the bottom of the E-Guide.',
          displayOnly: true,
        },
        sponsorLogos: {
          type: 'array',
          title: '',
          default: [],
          items: {
            type: 'object',
            properties: {
              url: {
                type: 'string',
                title: 'Sponsor Website URL',
              },
              image: {
                type: 'string',
                title: '',
              },
            },
          },
        },
        admin: {
          type: 'string',
          title: 'ADMIN',
          description: 'This section is for admin only.',
          displayOnly: true,
        },
        featuredSideImages: {
          type: 'array',
          title: '[ADMIN] Featured Side Images',
          description:
            'These images will be displayed on the top right of article, Max of 2 images, 1X1 image ratio',
          default: [],
          items: {
            type: 'object',
            required: ['src', 'sortIndex'],
            properties: {
              src: {
                type: 'string',
                title: 'Image File',
              },
              sortIndex: {
                type: 'number',
                title: 'Major Sort Index',
                description:
                  'Input number in all Major Sort Index fields if you wish to rearrenge order in page',
                default: 0,
              },
              url: {
                type: 'string',
                title: 'Image link',
              },
            },
          },
          maxItems: 2,
        },
      },
    },
    uiSchema: {
      basics: {
        'ui:widget': 'sectionWidget',
      },
      published: {
        'ui:widget': 'hidden',
      },
      meta: {
        'ui:widget': 'sectionWidget',
      },
      curation: {
        'ui:widget': 'sectionWidget',
      },
      eguide: {
        'ui:widget': 'sectionWidget',
      },
      exeCuration: {
        'ui:widget': 'sectionWidget',
      },
      sponsor: {
        'ui:widget': 'sectionWidget',
      },
      imageId: {
        'ui:widget': 'imageWidget',
      },
      heroImage: {
        'ui:widget': 'imageWidget',
      },
      metadata: {
        image: {
          'ui:widget': 'imageWidget',
          'ui:description': 'This image will be used when shared on social.',
        },
      },
      curatorImage: {
        'ui:widget': 'imageWidget',
        'ui:options': {
          canDelete: true,
        },
      },
      curatorBio: {
        'ui:widget': 'textarea',
        'ui:options': {
          rows: 5,
        },
      },
      admin: {
        'ui:widget': 'sectionWidget',
      },
      sponsorLogos: {
        items: {
          url: {
            'ui:widget': 'textarea',
            'ui:options': {
              rows: 1,
            },
          },
          image: {
            'ui:widget': 'imageWidget',
          },
        },
      },
      featuredSideImages: {
        'ui:options': {
          orderable: false,
        },
        items: {
          src: {
            'ui:widget': 'imageWidget',
          },
        },
      },
      sideImages: {
        'ui:options': {
          orderable: false,
        },
        items: {
          src: {
            'ui:widget': 'imageWidget',
          },
        },
      },
      lifeEventContentItems: {
        items: {
          itemContent: {
            'ui:widget': 'wysiwygWidget',
            'ui:options': {
              wysiwygConfig: {
                toolbar: {
                  options: ['link', 'list', 'inline', 'textAlign'],
                  link: {
                    showOpenOptionOnHover: false,
                  },
                  list: {
                    options: ['unordered'],
                  },
                  inline: {
                    inDropdown: false,
                    options: ['bold', 'italic'],
                  },
                  textAlign: {
                    inDropdown: false,
                    options: ['left', 'center', 'right', 'justify'],
                  },
                },
                editorClassName: 'form-control',
              },
              blockType: 'unordered-list-item',
            },
          },
        },
      },
      galleries: {
        items: {
          lifeEventVideos: {
            classNames: 'nested-field',
            'ui:options': {
              orderable: false,
            },
            items: {
              src: {
                'ui:widget': 'videoUrlWidget',
              },
              caption: {
                'ui:widget': 'textarea',
                'ui:options': {
                  rows: 1,
                },
              },
            },
          },
          lifeEventImages: {
            classNames: 'nested-field',
            'ui:options': {
              orderable: false,
            },
            items: {
              src: {
                'ui:widget': 'imageWidget',
              },
              caption: {
                'ui:widget': 'textarea',
                'ui:options': {
                  rows: 1,
                },
              },
            },
          },
        },
      },
      lifeEventCategoryIds: {
        'ui:field': 'hasManyField',
      },
      dropIds: {
        'ui:field': 'hasManyField',
        'ui:options': {
          sortField: ['label', 1],
        },
      },
      stickyDropIds: {
        'ui:field': 'hasManyField',
        'ui:options': {
          sortField: ['label', 1],
        },
      },
      updatedAt: {
        'ui:widget': 'hidden',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/schemas/admin/lifeEvent.js